import { render, staticRenderFns } from "./HeaderBar.vue?vue&type=template&id=b94a9936&scoped=true&"
import script from "./HeaderBar.vue?vue&type=script&lang=js&"
export * from "./HeaderBar.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBar.vue?vue&type=style&index=0&id=b94a9936&prod&lang=css&"
import style1 from "./HeaderBar.vue?vue&type=style&index=1&id=b94a9936&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94a9936",
  null
  
)

export default component.exports